import React from 'react';
import { useLocation } from 'react-router-dom';
import { I18n } from 'i18n';
import { useSelector } from 'react-redux';
import { Layout } from 'antd';
import { Log } from '../../weather/views/log';
import { GraphicWeatherRange } from '../../weather/views/historic-log';
import { GraphicWeatherFilters } from '../../weather/views/overview-daily-log';
import { Sider, Main } from '../components';

const ROUTES = [
  {
    name: I18n('daily_graph', true),
    key: 'daily-graph',
    path: '/environment/temperature-and-humidity/daily-graph',
    component: GraphicWeatherFilters,
  },
  {
    name: I18n('daily_graph_range', true),
    key: 'daily-graph-range',
    path: '/environment/temperature-and-humidity/daily-graph-range',
    component: GraphicWeatherRange,
  },
  {
    name: I18n('data_table', true),
    key: 'table',
    path: '/environment/temperature-and-humidity/table',
    component: Log,
  },
];

export function Weather() {
  const { collapseNav } = useSelector(({ app }) => app);
  const { pathname } = useLocation();
  const location = pathname.split('/');
  return (
    <Layout>
      {!collapseNav && (
        <Sider
          ROUTES={ROUTES}
          defaultSelectedKeys={location[3]}
          title={I18n('temperature_and_humidity', true)}
          key={'weather'}
        />
      )}
      <Main ROUTES={ROUTES} collapseNav={collapseNav} breadcrumb={location} />
    </Layout>
  );
}
